import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=558991bd&scoped=true&lang=scss"

import exportComponent from "/Users/misha/Dropbox/Mac/Documents/Git/strip-twister/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-558991bd"]])

export default __exports__